import type { ReactNode } from 'react';

export interface MnemonicGridProps {
  readonly mnemonic: string;
}

export function MnemonicGrid({ mnemonic }: MnemonicGridProps): ReactNode {
  const words = mnemonic.trim().split(/\s+/);
  return (
    <div className="grid grid-cols-3 gap-2 font-mono text-[13px]">
      {words.map((word, i) => (
        <div
          key={i}
          className="flex items-baseline gap-1 rounded-xl bg-surface-1 px-3 py-2.5"
        >
          <span className="text-[9px] opacity-50">{i + 1}</span>
          <span className="text-text-primary">{word}</span>
        </div>
      ))}
    </div>
  );
}
